import React, { useContext, useEffect, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { AppContext } from '../../../contexts/AppContext';
import { toast } from 'react-toastify';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import LazyLoading from '../../../components/LazyLoading';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { defaultUnitConversionDataForm, UnitConversion } from '../../../app/models/UnitConversion';
import { Product } from '../../../app/models/Product';
import { Unit } from '../../../app/models/Unit';
import UnitConversionForm from './forms/UnitConversionForm';
import useUnitConversionService from '../../../app/services/hooks/UseUnitConversionService';

interface Props {
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const UnitConversionCreate = ({ onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);

    const [errorGetData, setErrorGetData] = useState('');
    const [unitConversion, setUnitConversion] = useState<UnitConversion>(defaultUnitConversionDataForm);
    const [products, setProducts] = useState<Product[]>([]);
    const [rateUnits, setRateUnits] = useState<Unit[]>([]);
    const [quantityUnits, setQuantityUnits] = useState<Unit[]>([]);

    const [errorFields, setErrorFields] = useState<any>();

    const { fetchingStoreUnitConversion, fetchingCreateUnitConversion, createUnitConversion, storeUnitConversion } = useUnitConversionService();

    useEffect(() => {
        if (showLoading) showLoading('loading', 'Cargando datos...');

        createUnitConversion({
            onSuccess: (response: ServiceResponse) => {

                setProducts(response.data.products);
                setRateUnits(response.data.rate_units);
                setQuantityUnits(response.data.quantity_units);

                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    }, []);

    const store = () => {
        if (showLoading) showLoading('loading', 'Guardando impuesto...');
        storeUnitConversion(unitConversion, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    if (errorGetData !== '') {
        return <div>{errorGetData}</div>;
    }

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <UnitConversionForm
                        unitConversionDataForm={unitConversion}
                        setUnitConversionDataForm={setUnitConversion}
                        products={products}
                        rateUnits={rateUnits}
                        quantityUnits={quantityUnits}
                        errorFields={errorFields}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetchingStoreUnitConversion} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={store} locked={fetchingStoreUnitConversion} />
                </div>
            </div>
        </>
    );
};

export default UnitConversionCreate;
